'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var DnDTypes = exports.DnDTypes = {
    EVENT: 'event'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-big-scheduler/lib/DnDTypes.js
// module id = 283
// module chunks = 0